import { useRouter } from 'next/router';
import { useEffect } from 'react';

import { connect } from 'react-redux';

import { hexToRgb } from '@/helpers/string';
import { getUrlWithHost } from '@/helpers/url';
import { useActiveTheme } from '@/hooks/useActiveTheme';
import useMenuItems from '@/hooks/useMenuItems';
import { ServerStatus, SideBarPropsType } from '@/models/globalModels';
import { doCustomizeSideBar } from '@/redux/customizations/actions';
import { selectPortalCustomizationsCustomization, selectSidebarCustomTabs } from '@/redux/customizations/reducers';
import { RootState } from '@/redux/rootReducer';
import { envVars } from '@/services/ApiService';

import MenuItem from './MenuItem';

const mapDispatchToProps = {
  doCustomizeSideBar,
};

const mapStateToProps = (state: RootState) => {
  const customization = state.customizations;
  return {
    customization: selectPortalCustomizationsCustomization(state),
    customTabs: selectSidebarCustomTabs(state),
    customizationStatus: customization.customizationStatus,
  };
};

const SideBarMenu = ({ itemActive, customization, customizationStatus, doCustomizeSideBar, onClickCallback }: SideBarPropsType) => {
  const items = useMenuItems();
  const router = useRouter();
  const isItemActive = (key: string) => itemActive[0] == key;
  const { linkColor } = useActiveTheme();

  const onClick = (link: string) => {
    router.push(getUrlWithHost(link, envVars.checkHost));
  };

  useEffect(() => {
    if (customizationStatus === ServerStatus.FETCH && doCustomizeSideBar) {
      doCustomizeSideBar(customization);
    }
  }, [customizationStatus]);

  useEffect(() => {
    const color = hexToRgb(linkColor || '');
    if (customization && color) {
      document.body.style?.setProperty('--amba-sidebar-link-color', `${color.r}, ${color.g}, ${color.b}`);
    }
  }, [customization]);

  return (
    <div className="SideBarMenu">
      <div className="tabs f-raleway-regular">
        <ul className="list-unstyled">
          {items.map((item) => (
            <MenuItem
              key={item.id}
              {...item}
              active={isItemActive(item.id)}
              onClick={() => {
                onClick(item.link);
                onClickCallback && onClickCallback();
              }}
            />
          ))}
        </ul>
      </div>
    </div>
  );
};
// @ts-ignore
export default connect(mapStateToProps, mapDispatchToProps)(SideBarMenu);
